import { useCallback, useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { L2RToggleButtonGroup, Typography } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRoadworkUpdate } from "../../hooks/mutations/roadwork/useRoadworkUpdate"
import { useRoadworksProject } from "../../hooks/queries/useRoadworksProjectQuery"

import * as Styled from "./RoadworkYearSelector.styled"

export const RoadworkYearSelector = (props) => {
    const {
        roadwork,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const { data: project, isLoading: isLoadingProject } = useRoadworksProject()

    const roadworkUpdateMutation = useRoadworkUpdate(roadwork, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "components.roadworkDetailsForm.snackbar.success"),
    })

    const handleYearChanged = useCallback((year) => {
        roadworkUpdateMutation.mutate({
            year,
        })
    }, [roadworkUpdateMutation])

    const yearOptions = useMemo(() => {
        if (!project?.roadworksYears) {
            return []
        }

        const currentYear = (new Date()).getFullYear()
        const minYear = currentYear - 1
        const maxYear = Math.max(...project.roadworksYears)
        const options = []
        for (let year = minYear; year <= maxYear; year++) {
            options.push(
                {
                    value: year,
                    component: <Typography variant="Desktop & Mobile/Body/Small">{year}</Typography>,
                },
            )
        }

        return options
    }, [project?.roadworksYears])

    if (!project?.roadworksYears || isLoadingProject) {
        return <Styled.Skeleton />
    }

    return <L2RToggleButtonGroup
        id="roadwork-year-selector"
        {...props}
        onChange={handleYearChanged}
        enforceValue
        exclusive
        fullWidth
        options={yearOptions}
    />
}